'use strict';

var React = require('react');

var SvgThemeEditMajor = function SvgThemeEditMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 1.5a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5v.5h5a1 1 0 1 1 0 2h-5v1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5v2h-2v-2h-1.5a1.5 1.5 0 0 1-1.5-1.5v-4zm2 3.5v-3h4v3h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17v1h1v2h-1.5a1.5 1.5 0 0 1-1.5-1.5v-1.5h2zm-2-3v-3h2v3h-2zm9 6h-4v-2h4v2zm2-2h1v-1h2v1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5v-2zm2.907-13.159 2.252 2.252.375-.376a1.592 1.592 0 0 0-2.252-2.25l-.375.374zm1.218 3.283-2.251-2.251-7.143 7.143-.731 2.984 2.982-.731 7.143-7.144z"
  }));
};

exports.SvgThemeEditMajor = SvgThemeEditMajor;
